<template>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Filtro</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
                
                <v-col cols="6" sm="6" md="6">
                    <v-autocomplete
                        v-model="filter.cliente"
                        :items="clientes"
                        item-text="nomeFantasia"
                        item-value="nomeFantasia"
                        label="Cliente"
                        clearable
                        hide-details
                        hide-selected
                        solo
                    ></v-autocomplete>
                </v-col>

                <v-col cols="6" sm="6" md="6">
                    <v-autocomplete
                    v-model="filter.vendedor"
                    :items="vendedores"
                    item-text="name"
                    item-value="name"
                    label="Vendedor"
                    clearable
                    hide-details
                    hide-selected
                    solo
                    ></v-autocomplete>
                </v-col>

              <v-col cols="6" sm="6" md="6">
                <v-autocomplete
                  v-model="filter.orcamentista"
                  :items="orcamentistas"
                  item-text="name"
                  item-value="name"
                  label="Orçamentista"
                  clearable
                  hide-details
                  hide-selected
                  solo
                ></v-autocomplete>
              </v-col>
              
              <hr>
              <v-col cols="12" sm="12" md="12">

                <v-radio-group
                    v-model="filter.order"
                    inline
                >
                
                <template v-slot:label>
                    <div>Ordem Alfabetica</div>
                </template>
                    <v-radio
                        label="Ordernar"
                        value="1"
                    ></v-radio>
                    <v-radio
                        label="Não Ordernar"
                        value="-1"
                    ></v-radio>
                </v-radio-group>
            </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="$emit('close')">
            Cancelar
          </v-btn>
          <v-btn color="red" text @click="clearFilter">
            Limpar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'ModalFiterSalesOrder',
    props: ['open'],
    data() {
        return {
            filter: {
                cliente: null,
                fornecedor: null,
                orcamentista: null,
                order: "1"
            },
            dialog: false,
            fornecedores: [],
            materiais: [],
            orcamentistas: [],
            vendedores: [],
            clientes: []
        };
    },
    watch: {
        open(newVal) {
            this.dialog = newVal;

            if(newVal && this.clientes.length === 0) {
                this.getClientes();
            }

            if(newVal && this.orcamentistas.length === 0) {
                this.getOrcamentistas();
            }

            if(newVal && this.vendedores.length === 0) {
                this.getVendedores();
            }
        },

        filter: {
            handler() {
                this.$emit('filter-applied', this.filter)
            },
            deep: true
        }
    },
    methods: {

        async getClientes(){
            const response = await Vue.prototype.$http.get('/Entity/Cliente/search-fields', {
                params: {
                    page: 1,
                    limit: 3000000
                }
            })

            this.clientes = response.data.data.data
        },

        async getVendedores(){
            const response = await Vue.prototype.$http.get('/Entity/Collaborator/search-fields', {
                params: {
                    page: 1,
                    limit: 3000000,
                    searchFields: "[grupo],[status]",
                    value: '[Comercial Vendedores],[Ativo]'
                }
            })

            this.vendedores = response.data.data.data
        },

        async getOrcamentistas() {
            const response = await Vue.prototype.$http.get('/Entity/Collaborator/search-fields', {
                params: {
                    page: 1,
                    limit: 3000000,
                    searchFields: "typeCollaboratorOrcamentista,name",
                    value: '[Sim]'
                }
            })

            this.orcamentistas = response.data.data.data
        },

        clearFilter(){
            this.filter = {
                fornecedorId: null,
                filterdescricaoMaterial: null,
                order: "1"
            }
        }
    }
}

</script>